import * as React from 'react';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import MobileHeader from './MobileHeader';
import MobileBottomNavigation from './MobileBottomNavigation';

interface MobileLayoutProps {
  children: ReactNode;
  title?: string;
  sidebarContent?: ReactNode;
  onSidebarToggle?: (open: boolean) => void;
}

const MobileLayout: React.FC<MobileLayoutProps> = ({
  children,
  title,
  sidebarContent,
  onSidebarToggle
}) => {
  const location = useLocation();

  // Auto-generate title from path if not provided
  const getPageTitle = (pathname: string) => {
    switch (pathname) {
      case '/inventory': return 'Odoo Inventory';
      case '/tcg-oracle': return 'TCG Oracle';
      case '/tcg-box-search': return 'TCG Box Search';
      case '/settings': return 'Settings';
      default: return 'Trading Cards Admin';
    }
  };

  const pageTitle = title || getPageTitle(location.pathname);

  return (
    <div className="min-h-screen lg:hidden" style={{ backgroundColor: 'var(--color-primary-dark)' }}>
      {/* Mobile Header */}
      <MobileHeader
        title={pageTitle}
      />

      {/* Main Content */}
      <main className="pb-16 px-4 py-4 min-h-screen">
        {children}
      </main>

      {/* Bottom Navigation */}
      <MobileBottomNavigation />
    </div>
  );
};

export default MobileLayout;
